export type ConditionIconState = "negative" | "positive" | "neutral" | "uncertain";

const getSegmentColor = (conditionState: ConditionIconState) => {
	switch (conditionState) {
		case "negative":
			return "#ed544d";

		case "positive":
			return "#038331";

		case "neutral":
			return "#7ea6b4";

		case "uncertain":
			return "#e3b340";

		default:
			return "#7ea6b4";
	}
};

export const CaseDetailsRecordState = (props: {
	eligibilityConditionState: ConditionIconState;
	conclusiveConditionState: ConditionIconState;
}) => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.971 16.583a15.12 15.12 0 0 1 4.527-4.929L13.995 23H1a15.255 15.255 0 0 1 1.971-6.417z"
				fill="#038331"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 21.833 9.502 10.488a14.944 14.944 0 0 1 12.996 0L16 21.833z"
				fill={getSegmentColor(props.eligibilityConditionState)}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="m18.005 23 6.497-11.346a15.12 15.12 0 0 1 4.527 4.93A15.255 15.255 0 0 1 31 23H18.005z"
				fill={getSegmentColor(props.conclusiveConditionState)}
			/>
		</svg>
	);
};
